const toggleBodyClassOnHover = () => {
  const menuItems = document.querySelectorAll(
    '.c-nav__item--main.menu-item-has-children',
  );
  const bp = window.matchMedia('(min-width: 1024px)');

  if (bp.matches) {
    menuItems.forEach(item => {
      const dropdownWrapper = item.querySelector('.c-nav__dropdown-wrap');

      item.addEventListener('mouseenter', () => {
        document.body.classList.add('menu-open');

        if (dropdownWrapper) {
          const dropdownWrapperBox = dropdownWrapper.getBoundingClientRect();
          document.body.style.setProperty(
            '--nav-backdrop-height',
            `${dropdownWrapperBox.height}px`,
          );
        }
      });
      item.addEventListener('mouseleave', () => {
        document.body.classList.remove('menu-open');
      });
    });
  }
};

window.addEventListener('DOMContentLoaded', toggleBodyClassOnHover);



// WEBPACK FOOTER //
// ./src/scripts/modules/menu.js